import "../Body/body.css";
import { useTranslation } from "react-i18next";

export function Failsafefallback(){
    const { t } = useTranslation();
    return(
        <div className="container">
            <p className="exclamation">!</p>
            <p className='Graphik-Medium-Web' style={{textAlign:'center', fontSize:'large'}}> {t("FallbackMessage")}</p>
        </div>
    )
}